module.exports = __webpack_public_path__ + "assets/logo.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logo.png
// module id = 195
// module chunks = 0